// @flow
import React, { Component, Fragment } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Element } from 'react-scroll';
import Select from '../../../../../elements/Select/Select';
import { FormValidator } from '../../../../../utils/form';
import style from './DetailOption.scss';

import formStyle from '../../../../../assets/styles/form.scss';

import type { ScrappedDetailOptions } from '../../../../../entities';
import type { Option } from '../../../../../elements/Select/Select';

type Props = {
  handleChange: (dimension: string, value: string) => void;
  // options: { [key: string]: string[] };
  dimension: string;
  options: string[];
  selectedOption?: {
    value: string;
    errors?: string[];
    disabled?: {
      [key: string]: boolean;
    };
  };
};

const PILL_SELECT_THRESHOLD = 6;

export default class DetailOption extends Component<Props> {
  buildPill = () => {
    const { options, dimension, handleChange, selectedOption } = this.props;
    return (
      <div className={style.pillWrap}>
        {options.map((o: string, idx: number) =>
          <button key={idx}
                  className={classNames(style.pill, {
                    [style.active]: !!selectedOption && selectedOption.value === o,
                    [style.error]: !!selectedOption && selectedOption.errors,
                    [style.disabled]: !!selectedOption && !!selectedOption.disabled && selectedOption.disabled[o],
                  })}
                  onClick={(e: Event) => handleChange(dimension, o)}>{o}</button>)}
      </div>
    );
  };

  buildSelect = () => {
    const { options, dimension, handleChange, selectedOption } = this.props;
    // Here we let him choose a disabled option
    const opts = options
      /*.filter((o: string) => !selectedOption || !selectedOption.disabled ||
        (!!selectedOption && !!selectedOption.disabled && !selectedOption.disabled[o]))*/
      .map((o: string) => ({
        value: o,
        label: o,
      }));
    return (
      <div className={style.selectWrap}>
        <FormattedMessage id="newOrder.product.form.detailOption.placeholder">{
          txt => <Select options={opts}
                         className={classNames({
                           'light-blue': !!selectedOption && !!selectedOption.value,
                           'red': !!selectedOption && selectedOption.errors,
                         })}
                         value={!!selectedOption ? selectedOption.value : ''}
                         disabled={false}
                         searchable={true}
                         placeholder={txt}
                         handleChange={(op: Option) => handleChange(dimension, `${op.value}`)}/>
        }</FormattedMessage>
      </div>
    );
  };

  render() {
    const { options, dimension, selectedOption } = this.props;
    return <Element className={style.detailOptionWrap} name={dimension}>
      <label className={style.label}>{dimension}</label>
      {options.length <= PILL_SELECT_THRESHOLD && this.buildPill()}
      {options.length > PILL_SELECT_THRESHOLD && this.buildSelect()}
      {!!selectedOption && selectedOption.errors &&
      FormValidator.buildErrorLabel(selectedOption.errors, {
        required: 'newOrder.product.form.detailOption.error.required',
      })}
    </Element>
  }
}

DetailOption.propTypes = {
  handleChange: PropTypes.func.isRequired,
  dimension: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  selectedOption: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/ProductStep/components/DetailOption/DetailOption.jsx